export const VideoSection = () => {
  return (
    <section
      id="heroSection"
      style={{
        width: "100%",
        padding: "20px 20px",
        backgroundColor: "#ffffff",
        boxSizing: "border-box",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
      }}
    >
      <div
        style={{
          width: "100%",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <div
          style={{
            width: "80%",
            maxWidth: "960px",
            position: "relative",
            paddingBottom: "56.25%", // 16:9 aspect ratio
            height: 0,
          }}
        >
          <iframe
            src="https://streamable.com/e/cj1in6"
            title="Welcome To Piggyback"
            allow="accelerometer; autoplay"
            allowFullScreen
            style={{
              position: "absolute",
              top: 0,
              left: 0,
              width: "100%",
              height: "100%",
              border: "none",
              borderRadius: "16px",
            }}
          />
        </div>
      </div>
    </section>
  );
};
